import type { FunctionComponent } from 'react';

import {
  BreakPoints,
  Button,
  DesktopLayoutBoxed,
  DesktopLayoutBoxedContent,
  Header,
  Layout,
  Logo,
} from '@kanda-libs/ks-design-library';

import { URLS } from 'config';
import { Link } from 'react-router-dom';

import Footer from './Footer';
import useUpdateYourWebsite from './useUpdateYourWebsite';

const UpdateYourWebsite: FunctionComponent = function () {
  const { page, Content } = useUpdateYourWebsite();

  const content = (
    <>
      {Content && <Content />}
      <Footer page={page} />
    </>
  );

  const desktop = (
    <DesktopLayoutBoxed>
      <DesktopLayoutBoxedContent width="100">
        <>{content}</>
      </DesktopLayoutBoxedContent>
    </DesktopLayoutBoxed>
  );

  const mobile = (
    <Layout
      header={
        <Header.Base lines help>
          <Link to={URLS.home}>
            <Button.Icon
              id="home-mobile-back"
              icon="chevron-left"
              className="-ml-4"
            />
          </Link>
          <Logo />
        </Header.Base>
      }
    >
      <>{content}</>
    </Layout>
  );

  return <BreakPoints desktop={desktop} mobile={mobile} />;
};

export default UpdateYourWebsite;
